import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { from, Subscription } from 'rxjs';
import { Client } from 'src/app/models/client.model';
import { Refund1c, RefundModel } from 'src/app/models/refund.model';
import { DbService } from 'src/app/services/data/idb.service';
import { ReturnDbService } from 'src/app/services/data/return-db.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-refund-info',
  templateUrl: './refund-info.component.html',
  styleUrls: ['./refund-info.component.scss'],
})
export class RefundInfoComponent {
  id = '';
  refundInfo: RefundModel | undefined;
  preOrder: RefundModel | undefined;
  buypoint: Client | undefined
  loading: boolean;
  hasError = false;
  sub: Subscription | undefined;
  ignore = 0;

  private api: ReturnDbService;
  db: DbService

  constructor(
    private route: ActivatedRoute,
    private cm: ConnectionManagerService,
    private router: Router
  ) {
    this.loading = true;

    this.db = cm.getCurrentDb()
    this.api = new ReturnDbService(cm.getCurrentDb());
  }

  ngOnInit(): void {
    this.sub = this.cm.activeServerObservable().subscribe(() => {
      this.ignore++;
      if (this.ignore > 1) {
        this.router.navigateByUrl('/refunds');
      }
    });

    this.route.paramMap.subscribe((params) => {
      this.setId(params.get('id') as string);
    });
  }
  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  setId(orederId: string): void {
    this.id = orederId;
    this.reload();
  }

  reload() {
    this.loading = true;
    this.hasError = false;

    if (this.id !== '0') {
      this.api
        .getRefund(this.id)
        .then((data) => {
          if (!data) {
            return;
          } else {

              from(this.db.getClient(data.buypointId)).subscribe((c) => {
                this.buypoint = c

              })

            this.setData(data);
          }
        })
        .catch((error) => {
          console.log(error);

          this.hasError = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  setData(data: RefundModel) {
    this.refundInfo = data;
    this.preOrder = data;
    if (this.check1cItems() && this.refundInfo.orders1c) {
      this.preOrder = this.newPreord(this.refundInfo.orders1c[0]);
    }

    if (!data.orders1c || !data.orders1c.length) {
      this.refundInfo.summa1C = this.refundInfo.summa;
    } else {
      this.refundInfo.summa1C = data.items
        .map((x) => x.summa1C)
        .reduce((a, b) => a + b, 0);
    }
  }

  orderChanged(order: RefundModel): void {
    this.setData(order);
  }

  orderMain() {
    if (
      (!this.refundInfo?.kindId || this.refundInfo?.kindId === 1) &&
      this.refundInfo?.id === this.preOrder?.id
    ) {
      return true;
    }
    return false;
  }

  newPreord(preord: Refund1c) {
    const items = this.refundInfo?.items.filter(
      (x) => x.order1cId === preord.id
    );
    const prOrder: RefundModel = JSON.parse(JSON.stringify(preord));
    prOrder.items = [];

    if (items) {
      prOrder.items = items;
      prOrder.summa = items.map((x) => x.summa).reduce((a, b) => a + b, 0);
      prOrder.summa1C = items.map((x) => x.summa1C).reduce((a, b) => a + b, 0);
    }

    if (preord.id === this.refundInfo?.id) {
      prOrder.summa1C = this.refundInfo.summa1C;
    }

    return prOrder;
  }

  check1cItems() {
    if (this.refundInfo?.items?.filter((x) => !x.order1cId).length)
      return false;

    return true;
  }
}
